import { TacticIconType } from "./tacticIcons.types";
export const OfficeIcon: TacticIconType = (props) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6 9.75H7.5V11.25H6V9.75Z" fill="#161C22" />
    <path d="M9.25 9.75V11.25H10.75V9.75H9.25Z" fill="#161C22" />
    <path d="M9.25 6.5H10.75V8H9.25V6.5Z" fill="#161C22" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 2.5L14 3.5V14.5H2V7.5L6 6.5V2.5ZM7.5 7.67116V4.19917L12.5 4.82417V13H3.5V8.67116L7.5 7.67116Z"
      fill="#161C22"
    />
  </svg>
);
